import { z } from 'zod';

export const ScraperLogOperationSchema = z.object({
  titulo: z.string(),
  contenido: z.union([z.string(), z.number(), z.boolean(), z.null(), z.record(z.string(), z.unknown())])
});

export const ScraperInfoDataSchema = z.object({
  id: z.number().nullable().optional(),
  fecha_inicio: z.string().nullable().optional(),
  fecha_fin: z.string().nullable().optional(),
  total_time_seg: z.number().nullable().optional(),
  json_metadata: z.record(z.string(), z.string()).nullable().optional(),
  error: z.unknown().optional()
});

export const ScraperInfoResponseSchema = z.object({
  description: z.string(),
  status_code: z.number(),
  data: ScraperInfoDataSchema
});

export type ScraperLogOperation = z.infer<typeof ScraperLogOperationSchema>;
export type ScraperInfoData = z.infer<typeof ScraperInfoDataSchema>;
export type ScraperInfoResponse = z.infer<typeof ScraperInfoResponseSchema>;
